import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, PerspectiveLines } from "@/components/Reveal";

const services = [
  {
    n: "01",
    title: "Strategic Communications",
    desc: "Positioning, messaging, reputation management and stakeholder communications aligned with organisational objectives.",
    tags: ["Positioning", "Messaging", "Reputation", "Stakeholder Communications"],
  },
  {
    n: "02",
    title: "Public Relations & Media",
    desc: "Strategic media relations, earned media, corporate profiling, editorial campaigns and reputation building.",
    tags: ["Media Relations", "Earned Media", "Corporate Profiling", "Editorial Campaigns"],
  },
  {
    n: "03",
    title: "Thought Leadership",
    desc: "Positioning leaders and institutions through op-eds, interviews, Q&As, expert commentary and insight-led storytelling.",
    tags: ["Op-eds", "Interviews", "Expert Commentary", "Insight-led Storytelling"],
  },
  {
    n: "04",
    title: "Brand & Creative Communications",
    desc: "Brand narratives, creative campaigns, digital content, design and audio-visual storytelling.",
    tags: ["Brand Narratives", "Campaigns", "Digital Content", "Audio-visual"],
  },
  {
    n: "05",
    title: "Events & Experiences",
    desc: "Conferences, launches, stakeholder engagement and experiences designed to create visibility and meaningful connections.",
    tags: ["Conferences", "Launches", "Stakeholder Engagement", "Experiences"],
  },
];

export default function Services() {
  return (
    <main data-testid="services-page">
      <section className="mx-auto max-w-[1600px] px-6 pb-16 pt-40 sm:px-12 sm:pt-52" data-testid="services-hero">
        <p className="mb-8 text-xs uppercase tracking-[0.3em] text-primary">What We Do</p>
        <PerspectiveLines
          lines={["Five disciplines.", <>One outcome: <span className="text-primary">influence.</span></>]}
          className="font-syne text-[1.75rem] font-extrabold uppercase leading-[1.45] tracking-wider sm:text-[2.4rem] lg:text-[3.9rem]"
        />
      </section>

      <section className="mx-auto max-w-[1600px] px-6 pb-40 sm:px-12" data-testid="services-list">
        <div className="space-y-[220px]">
          {services.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.05}>
              <article className="group max-w-4xl" data-testid={`service-item-${s.n}`}>
                <span className="font-syne text-xs font-bold uppercase tracking-[0.35em] text-primary">
                  Discipline {s.n}
                </span>
                <h2 className="mt-10 font-syne text-4xl font-extrabold uppercase leading-[1.05] tracking-wide transition-colors duration-300 group-hover:text-primary sm:text-5xl lg:text-6xl">
                  {s.title}
                </h2>
                <p className="mt-12 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">{s.desc}</p>
                <p className="mt-10 text-xs uppercase tracking-[0.25em] text-muted-foreground/70">
                  {s.tags.join("  ·  ")}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-t border-black/10" data-testid="services-cta">
        <div className="mx-auto flex max-w-[1600px] flex-col gap-8 px-6 py-24 sm:flex-row sm:items-end sm:justify-between sm:px-12 sm:py-32">
          <Reveal>
            <h2 className="font-syne text-3xl font-extrabold uppercase tracking-wide sm:text-5xl">
              Ready to build <br />
              <span className="text-primary">real influence?</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <Link
              to="/contact"
              data-testid="services-cta-button"
              className="group flex w-max items-center gap-3 bg-primary px-8 py-4 font-syne text-sm font-bold uppercase tracking-[0.15em] text-primary-foreground transition-colors duration-300 hover:bg-foreground hover:text-background"
            >
              Begin a Conversation
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
